import ArticleIcon from './component.jsx'
export default ArticleIcon
